import React, { useState, useEffect } from 'react';
import ComponentSkeleton from './ComponentSkeleton';
import AnimatedComponentWrapper from './AnimatedComponentWrapper';
import ProgressiveComponentLoader from './ProgressiveComponentLoader';

const SmartComponentRenderer = ({ 
    component, 
    loadingState, 
    data, 
    children,
    skeletonType,
    chunkSize = 50,
    enableProgressive = true
}) => {
    const [isVisible, setIsVisible] = useState(false);
    //console.log("[SmartComponentRenderer]", component, "loadingState:", loadingState);
    
    useEffect(() => {
        if (loadingState.complete) {
            setTimeout(() => setIsVisible(true), 100);
        }
    }, [loadingState.complete]);
    
    if (!loadingState.complete) {
        return (
            <div className="smart-component-loading">
                <ComponentSkeleton type={skeletonType} />
                {loadingState.progress > 0 && (
                    <div className="loading-overlay p-3">
                        <div className="small text-center">
                            <div className="fw-bold">
                                {component.charAt(0).toUpperCase() + component.slice(1)}
                            </div>
                            <div className="text-muted">
                                {loadingState.progress}% completado
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
    
    return (
        <AnimatedComponentWrapper
            isLoading={false}
            loadingComponent={<ComponentSkeleton type={skeletonType} />}
        >
            {enableProgressive && data && data.length > chunkSize ? (
                <ProgressiveComponentLoader
                    data={data}
                    chunkSize={chunkSize}
                >
                    {/* ✅ PASAR CHILDREN CORRECTAMENTE */}
                    {children}
                </ProgressiveComponentLoader>
            ) : (
                // ✅ RENDERIZAR CHILDREN DIRECTAMENTE SI NO HAY PROGRESSIVE LOADING
                children
            )}
        </AnimatedComponentWrapper>
    );
};

export default SmartComponentRenderer;